import { rule } from 'ducks/entities/schema'

export const rulesApiV1ResponseSchema = {
  automation_rules: [rule],
}

export const ruleApiV1ResponseSchema = {
  automation_rule: rule,
}
